"use client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNavigation,
  CarouselNextButton,
  CarouselPrevButton,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import { Section } from "@/components/Section/Section";
import { SingleImageSliderOptionsType } from "@/types/ModuleOptionsType";
import { Modul_Einzelbild_Slider } from "@aleksundshantu/gp-types/acf-module";
import styles from "./SingleImageSlider.module.scss";
import { FadeInUp } from "@/components/Animation/ScrollAnimation";
import { CarouselExtraProvider } from "@/context/CarouselExtraContext";
import SingleImageSliderElement from "./SingleImageSliderElement";
import { Headline } from "@/components/Headline/Headline";
import { ExtendedLink } from "@/components/ExtededLink/ExtendedLink";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

interface SingleImageSliderProps {
  data: Modul_Einzelbild_Slider;
  options: SingleImageSliderOptionsType;
}

export const SingleImageSlider = ({
  data,
  options,
}: SingleImageSliderProps) => {
  const { media_format, slider_options, box } = options;

  const { show_card_box, show_border_radius, show_box_shadow } = box;

  const {
    headline,
    headline_html_tag,
    overline,
    subline,
    elements,
    link_extended,
    content,
  } = data.single_image_slider;

  const {
    background_color_class,
    id,
    module_width,
    section_margin_class,
    section_padding_class,
    // headline_text_align_class,
    image_keep_ratio,
  } = data.layout;

  const { getLabel } = useGlobalContext();
  return (
    <Section
      id={id}
      columnsClassName="is-centered is-multiline my-0"
      frameless={module_width === "frameless"}
      className={`single-image-slider is-centered ${background_color_class} ${section_margin_class} ${section_padding_class}`}
    >
      {/* <div className={`column is-relative `}> */}
      <FadeInUp className="column is-12">
        {(headline || content) && headline_html_tag && (
          <Headline
            headline_html_tag={headline_html_tag}
            headline={headline}
            extraClass={`pt-4 has-text-centered`}
            overline={overline}
            subline={subline}
            wrapInSection={module_width === "frameless"}
            disableAnimation
            text={content}
            textExtraClass={`has-text-centered`}
            innerClasses="column is-10-desktop"
            disableColumns={false}
          />
        )}
      </FadeInUp>

      <FadeInUp>
        <Carousel
          autoplay={
            slider_options.slider_navigation === "only-navigation-autoplay"
          }
          loop={slider_options.has_looping}
          align={"center"}
          slidesToScroll={1}
          className={styles["carousel-wrapper"]}
        >
          <CarouselNavigation
            className={`is-hidden-desktop ${slider_options.slider_navigation}`}
            type={slider_options.slider_navigation}
          />
          <CarouselExtraProvider enableTween={true} tweenSelector=".slide-card">
            <CarouselContent
              spacing="32px"
              extraClasses={`${styles["carousel-content"]} `}
            >
              {(elements ? elements : []).map(({ image }, index) => {
                return (
                  <CarouselItem
                    key={index}
                    // itemWidth={"50%"}
                    itemWidth={{
                      mobile: "75%",
                      tablet: "75%",
                      desktop: "60%",
                      widescreen: "60%",
                      fullhd: "50%",
                      ultrahd: "50%",
                    }}
                    className={`${styles["carousel-item"]}`}
                  >
                    {/* <article
                        className={`${styles["carousel-item-content"]} columns is-flex-direction-column is-centered is-gapless  m-0 ${show_card_box ? "is-box" : ""} ${show_border_radius && show_card_box ? "has-border-radius" : ""} ${show_box_shadow && show_card_box ? "has-box-shadow" : ""} ${show_card_box && image_keep_ratio ? "p-3" : ""}`}
                      >
                        {image && (
                          <MediaItem
                            image_desktop={image}
                            sizes="100%"
                            priority={true}
                            mediaFormat={
                              image_keep_ratio ? undefined : media_format
                            }
                            objectFit={image_keep_ratio ? "contain" : "cover"}
                            className="has-border-radius"
                          />
                        )}
                        {caption && (
                          <p
                            ref={(el) => {
                              {
                                captionRefs.current[index] = el;
                              }
                            }}
                            className={`${styles["image-caption"]} ${image_keep_ratio ? "pt-3" : "p-3"}`}
                            dangerouslySetInnerHTML={{ __html: caption }}
                          />
                        )}
                      </article> */}
                    <SingleImageSliderElement
                      image={image}
                      show_card_box={show_card_box}
                      show_border_radius={show_border_radius}
                      show_box_shadow={show_box_shadow}
                      image_keep_ratio={image_keep_ratio}
                      media_format={media_format}
                      index={index}
                    />
                  </CarouselItem>
                );
              })}
            </CarouselContent>

            {slider_options.slider_navigation == "only-navigation" ||
            slider_options.slider_navigation == "only-navigation-autoplay" ? (
              <>
                <div
                  className={`${styles["embla-navigation"]}`}
                  // style={{
                  //   ["--y-offset" as string]: `${imageCaptionHeight}px`,
                  // }}
                >
                  <CarouselPrevButton />
                  <CarouselNextButton />
                </div>
              </>
            ) : (
              <CarouselNavigation
                className={`is-hidden-touch ${slider_options.slider_navigation}`}
                type={slider_options.slider_navigation}
              />
            )}
          </CarouselExtraProvider>
        </Carousel>
      </FadeInUp>
      {link_extended && (
        <div className="is-flex is-justify-content-center">
          <ExtendedLink
            extendedLink={link_extended}
            getLabel={getLabel}
            btnType="primary"
          />
        </div>
      )}
      {/* </div> */}
    </Section>
  );
};
